module.exports = __webpack_public_path__ + "static/media/13_l_palatki_0_53.15.80122e77.png";